import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const intellishiftConfig: TSPConfig = {
  key: 'intellishift',
  name: 'IntelliShift',
  category: TSPCategory.CUSTOM,
  helpText:
    'Please request an API username and password from IntelliShift support. Then input them here.',
  loginComponent: (props) => (
    <LoginCreds
      onValidityChange={props.onValidityChange}
      fields={[
        {
          label: 'API Username',
          name: 'username',
          type: 'text',
          required: true,
        },
        {
          label: 'API Password',
          name: 'password',
          type: 'password',
          required: true,
        },
      ]}
    />
  ),
};

export default intellishiftConfig;
